import React from "react"

export const Title = ({ title }) => {
  return (
    <>
      <h1 className='text-3xl font-bold mb-5 text-secondary'>{title}</h1>
    </>
  )
}
